export default __webpack_public_path__ + "static/media/c10.2ed9fcf3.png";